const URL_PATH_SEPARATOR = '/'
const PROTOCOL_RELATIVE_PREFIX = '//'
const RELATIVE_PATH_PREFIX = `.${URL_PATH_SEPARATOR}`
const QUERY_PREFIX = '?'
const DEVELOPMENT_ENVIRONMENT = 'development'
export const LTS_VERSION = 'lts'
const FILLED_ICON_FAMILY = 'filled'
const FILLED_ICON_SUFFIX = '-fill'
const LEADING_PATH_SEPARATORS = /^[/\\]+/
const TRAILING_PATH_SEPARATORS = /\/+$/
const DEFAULT_RELATIVE_URL_BASE = new URL('https://url.invalid/')
const REMOTE_STORYBOOK_ORIGIN = new URL('https://backpack-storybook.trustagedemo.com')
const BOOTSTRAP_ICON_BASE_URL = new URL('https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/icons/')
const STATIC_DEMO_CDN_ORIGIN = new URL('https://static-demo.trustage.com')
const STATIC_DEMO_BASE_URL = new URL('/ascend/', STATIC_DEMO_CDN_ORIGIN)
const WEB_AWESOME_ORIGIN = new URL('https://early.webawesome.com')
const WEB_AWESOME_PACKAGE_NAME = 'webawesome'
const LOCAL_STORYBOOK_BASE_URL = new URL('http://localhost:6006/')

export const STORYBOOK_AUDIT_MODULE_PATH =
    'storybook-internal/generated/internal-designsystem-audit.js'
export const STORYBOOK_DOCS_MODULE_PATH =
    'storybook-internal/generated/internal-designsystem-docs.js'
export const DEMO_STORYBOOK_OPTIONS = Object.freeze({
    environment: 'demo',
    version: LTS_VERSION,
    remote: true,
})
export const WEB_AWESOME_DEFAULT_VERSION = '3.0.0-beta.6'
export const STATIC_DEMO_CDN_ROOT = STATIC_DEMO_CDN_ORIGIN.origin
export const STATIC_PRODUCTION_CDN_ROOT = new URL('https://static.trustage.com').origin
export const REMOTE_STORYBOOK_BASE_URL = REMOTE_STORYBOOK_ORIGIN.href
export const LOCAL_STORYBOOK_URL = LOCAL_STORYBOOK_BASE_URL.href

function isAbsoluteUrl(url) {
    try {
        new URL(url)
        return true
    } catch {
        return false
    }
}

function appendPath(baseUrl, path) {
    const directoryUrl = new URL(baseUrl.href)
    directoryUrl.pathname = `${directoryUrl.pathname.replace(TRAILING_PATH_SEPARATORS, '')}${URL_PATH_SEPARATOR}`
    const relativePath = path.replace(LEADING_PATH_SEPARATORS, '')
    return parseUrl(`${RELATIVE_PATH_PREFIX}${relativePath}`, directoryUrl.href)
}

/** @param {string} base @param {...string} paths */
export function joinUrl(base = '', ...paths) {
    const absolute = isAbsoluteUrl(base)
    const protocolRelative = base.startsWith(PROTOCOL_RELATIVE_PREFIX)
    let url = parseUrl(base || URL_PATH_SEPARATOR, DEFAULT_RELATIVE_URL_BASE)
    for (const path of paths.filter(Boolean)) {
        url = appendPath(url, path)
    }
    if (!base && !paths.some(Boolean)) return ''
    if (absolute) return url.href
    if (protocolRelative) return url.href.slice(url.protocol.length)
    return url.href.slice(url.origin.length)
}

/** @param {string} url @param {string} base @param {Record<string, string>} query */
export function resolveUrl(url, base, query = {}) {
    const resolvedUrl = parseUrl(url, base)
    for (const [name, value] of Object.entries(query)) resolvedUrl.searchParams.set(name, value)
    return resolvedUrl.href
}

export function parseUrl(url, base) {
    return new URL(url, base)
}

export function storybookUrl(path = '', { environment = DEVELOPMENT_ENVIRONMENT, version = '', remote = false } = {}) {
    const isDevelopment = environment.toLowerCase() === DEVELOPMENT_ENVIRONMENT
    if (isDevelopment && path.startsWith(QUERY_PREFIX)) return path
    const base = isDevelopment
        ? ''
        : joinUrl(remote ? REMOTE_STORYBOOK_ORIGIN.href : '', version)
    return joinUrl(base, path)
}

export function bootstrapIconUrl(name, family = '') {
    const suffix = family === FILLED_ICON_FAMILY ? FILLED_ICON_SUFFIX : ''
    return joinUrl(BOOTSTRAP_ICON_BASE_URL.href, `${name}${suffix}.svg`)
}

export function demoExampleUrl(path, version = LTS_VERSION) {
    return joinUrl(STATIC_DEMO_BASE_URL.href, version, path)
}

export function webAwesomeUrl(path, version = WEB_AWESOME_DEFAULT_VERSION) {
    const packagePath = version ? `${WEB_AWESOME_PACKAGE_NAME}@${version}` : WEB_AWESOME_PACKAGE_NAME
    return joinUrl(WEB_AWESOME_ORIGIN.href, packagePath, path)
}

export function isWebAwesomeUrl(url) {
    try {
        const parsedUrl = parseUrl(url)
        return (
            parsedUrl.origin === WEB_AWESOME_ORIGIN.origin &&
            (parsedUrl.pathname === `/${WEB_AWESOME_PACKAGE_NAME}` ||
                parsedUrl.pathname.startsWith(`/${WEB_AWESOME_PACKAGE_NAME}/`) ||
                parsedUrl.pathname.startsWith(`/${WEB_AWESOME_PACKAGE_NAME}@`))
        )
    } catch {
        return false
    }
}